import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Horse Moon',
    description: 'Horse Moon là nền tảng phân tích chứng khoán Việt Nam đa vai trò: bảy góc nhìn kỹ thuật, cơ bản, dòng tiền, vĩ mô, tin tức, rủi ro và một kết luận tổng hợp để tìm sóng ngành và mã đáng mua sớm.',
    placeholder: '',
    url: getOrigin()
}
